function hasValue(value) {
	return value !== undefined && value !== null && value !== ''
}

function getFlowSettingRedirect(to) {
	const query = to && to.query ? to.query : {}

	if (to && to.name === 'flowSetting' && hasValue(query.live_id) && hasValue(query.record_id)) {
		return {
			name: 'liveFlowSetting',
			query,
			replace: true,
		}
	}

	return null
}

module.exports = {
	getFlowSettingRedirect,
}
